type ReferenceCount = { reference: string; count: number };
export type PreviewLine = { label: string; count: number };

/** Records a user opens and recognizes; these lead the preview. Keyed by the moved table. */
const HEADLINE: Record<string, string> = {
  SalesOrder: 'Sales orders',
  PurchaseOrder: 'Purchase orders',
  BuySellOrder: 'Buy/sell orders',
  WorkOrder: 'Grower products',
  LineItem: 'Sourced order lines',
  Bill: 'Bills',
  Expense: 'Expenses',
  Payment: 'Payments',
  StandardInvoice: 'Invoices',
  StandardPayable: 'Payables',
  Contact: 'Contacts',
  Place: 'Addresses',
  Shipment: 'Shipments',
  Load: 'Loads',
  Conversation: 'Conversations',
  _BusinessEntityToCustomerGroup: 'Customer groups',
  _BusinessEntityToPricingSheet: 'Pricing sheets',
};

/** Background links that follow the survivor; shown on one muted line, never as the headline. */
const ALSO_CARRIED: Record<string, string> = {
  BusinessEntityLearning: 'saved name matches',
  AiCorrection: 'saved name matches',
  ThirdPartyIntegrationEntityLink: 'ERP links',
  EdiProductMapping: 'EDI product mappings',
  GuestMembership: 'portal access grants',
  LotSupplierSource: 'lot supplier records',
};

function sumByLabel(counts: ReferenceCount[], labelOf: (table: string) => string | undefined) {
  const totals = new Map<string, number>();
  for (const { reference, count } of counts) {
    const label = labelOf(reference.split('.')[0] ?? reference);
    if (label && count > 0) totals.set(label, (totals.get(label) ?? 0) + count);
  }
  return [...totals].map(([label, count]) => ({ label, count }));
}

/** Splits merge-preview counts into user-visible records and the background links carried along. */
export function summarizeMergePreview(referenceCounts: ReferenceCount[]) {
  return {
    headline: sumByLabel(referenceCounts, (table) => HEADLINE[table]),
    alsoCarried: sumByLabel(referenceCounts, (table) =>
      HEADLINE[table] ? undefined : (ALSO_CARRIED[table] ?? table.replace(/([a-z])([A-Z])/g, '$1 $2').toLowerCase())
    ),
  };
}
